import { z } from 'zod';

import { zodSiteResponseSchema } from '../useQuerySite/validations';

export const zodSitesBulkPayloadSchema = z.object({
  ids: z.array(z.uuid()).max(2000),
});

export const zodSitesBulkResponseSchema = z.object({
  items: z.array(zodSiteResponseSchema),
});
